import React, { useCallback } from 'react';
import Login from '@/components/Login/Login';
import Dashboard from '@/components/Dashboard/Dashboard';
import ToastContainer from '@/components/ui/ToastContainer';
import { useAuthValidation } from '@/hooks/useAuthValidation';

const App: React.FC = () => {
  const { isValidating, isValid, validateToken, logout } = useAuthValidation();

  const handleLoginSuccess = useCallback(() => {
    void validateToken();
  }, [validateToken]);

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  if (isValidating) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-medium mx-auto mb-4"></div>
          <p className="text-gray-600">Validando sesión...</p>
        </div>
      </div>
    );
  }

  if (!isValid) {
    return (
      <>
        <Login onLoginSuccess={handleLoginSuccess} />
        <ToastContainer />
      </>
    );
  }
  return (
    <>
      <Dashboard onLogout={handleLogout} />
      <ToastContainer />
    </>
  );
};

export default App;
